export default __webpack_public_path__ + "static/media/send_email.ac2991f3.gif";